import React from 'react';

const awards = [
  {
    img: 'https://ik.imagekit.io/kqumni8l2/kcs-products/Office24by7/office24by7%20image%20(1).png?updatedAt=1751612421272',
    alt: 'Category Leader 2024',
    label: 'Software Advice Category Leader 2024',
  },
  {
    img: 'https://ik.imagekit.io/kqumni8l2/kcs-products/Office24by7/office24by7%20image.jpeg?updatedAt=1751612720433',
    alt: 'User Recommended 2022',
    label: 'Software Advice User Recommended 2022',
  },
  {
    img: 'https://ik.imagekit.io/kqumni8l2/kcs-products/Office24by7/office24by7%20image%20(1).jpeg?updatedAt=1751612720550',
    alt: 'Best Value Software 2022',
    label: 'Software Advice Best Value Software 2022',
  },
  {
    img: 'https://ik.imagekit.io/kqumni8l2/kcs-products/Office24by7/office24by7%20image%20(2).jpeg?updatedAt=1751612720645',
    alt: 'Best Value 2021',
    label: 'Software Advice Best Value 2021',
  },
];

const certifications = [
  {
    img: 'https://ik.imagekit.io/kqumni8l2/kcs-products/Office24by7/image%20(3).jpeg?updatedAt=1751612720286',
    alt: 'ISO 9001:2015',
    title: 'Quality Management',
    desc: 'ISO 9001:2015 Certified Company',
  },
  {
    img: 'https://ik.imagekit.io/kqumni8l2/kcs-products/Office24by7/image%20(2).jpeg?updatedAt=1751612720330',
    alt: 'ISO 27001:2022',
    title: 'Information Security Management System',
    desc: 'ISO 27001:2022 Certified Company',
  },
];

const Awards = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f8fafc' }}>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Section */}
          <div>
            <h1
              className="text-4xl lg:text-5xl font-bold mb-6"
              style={{ color: '#1e293b' }}
            >
              Journey to Leadership
              <br />
              Since 2020
            </h1>
            <p
              className="text-lg mb-8"
              style={{ color: '#334155' }}
            >
              Top reviewers rate Office24by7 as the best in the industry.
            </p>

            {/* Awards Section */}
            <div className="flex flex-wrap gap-6 mb-12 justify-center">
              {awards.map((award, idx) => (
                <div
                  key={idx}
                  className="w-28 h-28 bg-white rounded-2xl shadow-md flex flex-col items-center justify-center p-3 border"
                  style={{ borderColor: '#e0e7ef' }}
                >
                  <img
                    src={award.img}
                    alt={award.alt}
                    className=" mb-2"
                    style={{ filter: 'drop-shadow(0 2px 6px #2563eb33)' }}
                  />
                 
                </div>
              ))}
            </div>

            {/* Certifications */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              {certifications.map((cert, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center"
                  style={{ borderColor: '#e0e7ef' }}
                >
                  <img
                    src={cert.img}
                    alt={cert.alt}
                    className="w-20 h-20 mb-4"
                    style={{ filter: 'drop-shadow(0 2px 6px #2563eb33)' }}
                  />
                  <div className="text-center">
                   
                    <p
                      className="text-sm"
                      style={{ color: '#64748b' }}
                    >
                      {cert.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Section */}
          <div
            className="bg-white rounded-2xl p-10 shadow-lg flex flex-col items-center justify-center"
            style={{ borderColor: '#e0e7ef', borderWidth: 1 }}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/565/565547.png"
              alt="Privacy"
              className="w-20 h-20 mb-6"
              style={{ filter: 'drop-shadow(0 2px 6px #05966933)' }}
            />
            <h2
              className="text-3xl font-bold mb-4 text-center"
              style={{ color: '#059669' }}
            >
              Your Privacy Is Our Priority
            </h2>
            <p
              className="mb-4 text-center"
              style={{ color: '#334155', fontSize: '1.1rem' }}
            >
              Our unwavering commitment to privacy and compliance is backed by comprehensive security certifications.
            </p>
            <div className="flex items-center gap-2 mt-2">
              <img
                src="https://cdn-icons-png.flaticon.com/512/190/190411.png"
                alt="ISO"
                className="w-8 h-8"
              />
              <span className="text-sm " style={{ color: '#64748b' }}>
                ISO Certified & Secure
              </span>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Awards;